import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";

export default function SpaFaqs({ data }) {
  const [active, setActive] = useState("0");
  return (
    <>
      <section className='spafaq-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className="spa-faq-wrapper">
                <Accordion activeKey={active} onSelect={(e) => setActive(e)}>
                  {data?.map((item, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                      <Accordion.Header as="span">
                        {item.title}
                        <div className="right-icon">
                          {active === index.toString() ? "-" : "+"}
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>{item.desc}</p>
                        <span>{item.duration}</span>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}